import { Injectable } from '@angular/core';
import { Activity, LenderUserActivity, LenderUserActivityResponse } from 'app/models/dto/activity.model';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(private api: ApiHttpClient) { }

  getLatestActivities({ limit, offset, criteria}): Observable<Activity[]> {
    const url = `${environment.API_URL}/activity`;
    return this.api.get<Activity[]>(url, {
      params: {
        notifications: 'true',
        query: JSON.stringify({
          limit,
          offset,
          sort: { 'activities.created': 'DESC' },
          criteria: {
            'activities.type': { in: [...criteria.types] },
            'activities.created': { '>=': criteria.start, '<=': criteria.end }
          }
        })
      }
    }).pipe(
      catchError(() => of([]))
    );
  }

  getMoreActivities({ limit, offset, criteria }): Observable<Activity[]> {
    const url = `${environment.API_URL}/activity`;
    return this.api.get<Activity[]>(url, {
      params: {
        notifications: 'true',
        query: JSON.stringify({
          limit,
          offset,
          sort: { 'activities.created': 'DESC' },
          criteria: {
            'activities.type': { in: [...criteria.types] },
            'activities.created': { '>=': criteria.start, '<=': criteria.end }
          }
        })
      }
    }).pipe(
      catchError(() => of([]))
    );
  }

  markLatestActivitiesViewed(userId: number): Observable<any> {
    return this.api.put(`${environment.API_URL}/lender-user/${userId}`, {
      settings: { lastViewedNotification: 1 }
    });
  }

  getLenderUserActivities(lenderUserId: number, queryFilters: string[], paginationPage = 1): Observable<LenderUserActivityResponse> {
    const url = `${environment.API_URL}/lender-user/${lenderUserId}/activities`;
    const params = {
      query: JSON.stringify({
        criteria: { 'activities.type': {
          in: [...queryFilters]
        } }
      }),
      page: paginationPage
    };
    const defaultKeys = [
      'id',
      'type',
      'subType',
      'borrowerId',
      'borrowerName',
      'createdTimestamp',
      'deletedType',
    ];
    return this.api.get<LenderUserActivityResponse>(url, { params }).pipe(
      map(
        (response: LenderUserActivityResponse) => {
          const lenderUserActivities: LenderUserActivity[] = response?.data ?? [];
          if (lenderUserActivities) {
            lenderUserActivities.forEach((lenderUserActivity: LenderUserActivity) => {
              if (!lenderUserActivity['meta']) {
                lenderUserActivity['meta'] = {};
              }
              for (const [key, value] of Object.entries(lenderUserActivity)) {
                if (!defaultKeys.includes(key) && key !== 'meta') {
                  lenderUserActivity['meta'][key] = value;
                  delete lenderUserActivity[key];
                }
              }
            });
          }
          // Update transformed lenderUserActivities. Can't mutate response.
          const finalResponse = {
            data: lenderUserActivities,
            links: response?.links,
            meta: response?.meta
          };

          return finalResponse;
        }
      )
    );
  }
}
